import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    maxHeight: '50px',
    width: '100%',
    maxWidth: '50px'
  },

  avatarSolo: {
    width: '40px !important',
    height: '40px !important',
    fontSize: `${theme.size.base} !important`,

    [theme.breakpoints.down('md')]: {
      width: '2rem !important',
      height: '2rem !important'
    }
  },

  avatarDuo: {
    width: '25px !important',
    height: '25px !important',
    fontSize: `${theme.size.sm} !important`
  },

  avatarGroup: {
    width: '25px !important',
    height: '25px !important',
    fontSize: `${theme.size.sm} !important`
  },

  groupDuo: {
    '& > div': {
      position: 'absolute'
    },

    '& > div:nth-child(1)': {
      left: '0'
    },

    '& > div:nth-child(2)': {
      right: '0'
    },

    '& > div:nth-child(2) > span > div': {
      border: '2px solid white'
    }
  },

  groupMulti: {
    '& > div': {
      position: 'absolute'
    },

    '& > div:nth-child(1)': {
      top: '0',
      left: '50%',
      transform: 'translateX(-50%)'
    },

    '& > div:nth-child(2)': {
      left: '0',
      bottom: '0'
    },

    '& > div:nth-child(3)': {
      right: '0',
      bottom: '0'
    },

    '& > div:not(:first-child) > span > div': {
      border: '2px solid white'
    }
  }
}))

export default useStyles
